var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbCircleWinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.105 12.5407C25.105 5.61393 19.4858 0 12.5525 0C5.61922 0 0 5.61393 0 12.5407C0 19.4675 5.61922 25.0814 12.5525 25.0814C12.6261 25.0814 12.6996 25.0814 12.7732 25.0765V15.3183H10.0763V12.1782H12.7732V9.86602C12.7732 7.18642 14.4109 5.7266 16.8037 5.7266C17.9511 5.7266 18.9367 5.80988 19.221 5.84907V8.65113H17.5735C16.2741 8.65113 16.0192 9.26837 16.0192 10.1746V12.1733H19.1328L18.7258 15.3134H16.0192V24.5965C21.2657 23.0926 25.105 18.2673 25.105 12.5407Z",
    fill: "#0871B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbCircleWinter);
export default __webpack_public_path__ + "static/media/FB-circle-winter.c5cd7d122c4461b4f5ff29e75cf1387a.svg";
export { ForwardRef as ReactComponent };